// src/utils/persianUtils.ts

/**
 * Converts English digits (0-9) to Persian digits (۰-۹).
 * Handles numbers, strings, or null/undefined values.
 */
export const toPersianDigits = (value: number | string | undefined | null): string => {
    if (value === null || value === undefined) return '';

    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

    return value.toString().replace(/[0-9]/g, (w) => persianDigits[+w]);
};
